import { useEffect, useRef, useState } from 'react';
import '../styles/viewPrescriptionHistory.scss';
import '../styles/MedicalReport.scss';
import { parseBillHTML } from '../utils/billParser';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import {Editor} from '@tinymce/tinymce-react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { CRUDRecordPopup } from '../Redux/Slice/rootSlice';
import { getPatientsBillReportView, getPatientsReportView, updatePatientReport } from '../Redux/Thunk/Actions';

function ViewPatientReport({loaderchange, popupalert, popuptext}) {
  const sideActive = useSelector(state => state.counter.sidebarnav);
  const activeTab = useSelector(state => state.counter.menuPrescriptionTab);
  console.log(activeTab, 'test');
  const reportViewId = useSelector(state => state.counter.reportViewId);
  let recordpopup = useSelector(state => state.counter.recordpopup);
  const [response, setResponse] = useState();
  const [structuredBillData, setStructuredBillData] = useState(null);

  const fetchReportViewType = useSelector(state => state.counter.reportViewTypeData);
  const [recordCRUDpopup, setRecordCRUDpopup] = useState(recordpopup);
  const dispatch = useDispatch();
  const [reportView_Type, setReportView_Type] = useState('');
  const [printTrigger, setPrintTrigger] = useState(false);
  const location = useLocation();
  const isEditMode = location.state?.mode === 'edit' && fetchReportViewType === 'Patient Reports';
  const [editorValue, setEditorValue] = useState('');

  useEffect(() => {
    const handleThunk = async props => {
      loaderchange(true);
      const payload = reportViewId;

      let patentDetails;
      if (fetchReportViewType === 'Patient Billing') {
        patentDetails = getPatientsBillReportView(payload);
      } else if (fetchReportViewType === 'Patient Reports') {
        patentDetails = getPatientsReportView(payload);
      }
      const response = await dispatch(patentDetails);
      // dispatch(reportViewType(""));
      if (response?.payload?.status?.code === 200) {
        loaderchange(false);
        const billData = response.payload.data;
        if (fetchReportViewType === 'Patient Billing' && billData.report_template && !billData.pharmacy_price) {
          const parsedData = parseBillHTML(billData.report_template);
          setStructuredBillData(parsedData);
        }
        setResponse(billData.report_template);
        if (isEditMode) {
          setEditorValue(billData.report_template || '');
        }

        // setResponse(response.payload.data.prescription_template);
      } else {
        loaderchange('false');
        popupalert('true');
        popuptext('Network went wrong billing, Please try after some time.');
        popuptext(response?.status?.message);
        setTimeout(() => {
          popupalert('false');
        }, 2000);
      }
    };
    setReportView_Type(fetchReportViewType);
    handleThunk();
    setPrintTrigger(false);
  }, []);

  // function PrintDiv() {
  //   var printHtml = window.open("", "PRINT", "height=800,width=900");

  //   printHtml.document.write("<html><head>");
  //   printHtml.document.write(document.getElementById("demo").innerHTML);
  //   printHtml.document.write("</body></html>");

  //   printHtml.document.close();
  //   printHtml.focus();

  //   printHtml.print();
  //   printHtml.close();

  //   return true;
  // }
  const divRef = useRef(null);
  const Share = async e => {
    console.log('Going', 'pdfpdfpdfpdfpdfpdfpdf');
    try {
      console.log('Going in', 'pdfpdfpdfpdfpdfpdfpdf');
      // Convert the div to canvas
      const canvas = await html2canvas(divRef.current);

      // Convert canvas to PDF
      const pdf = new jsPDF('p', 'mm', 'a4');
      pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());

      // Convert PDF to Base64 string
      const pdfBase64 = pdf.output('datauristring');
      console.log(pdfBase64, 'pdfpdfpdfpdfpdfpdfpdf');

      // Store the Base64 string in Local Storage
      localStorage.setItem('pdfData', pdfBase64);

      // Provide an option for the user to input a WhatsApp number and handle the sharing process using the WhatsApp API or similar service
      // Example:
      const whatsappNumber = prompt('Enter WhatsApp number');
      if (whatsappNumber) {
        // Use an API to share the PDF via WhatsApp
        // Example: axios.post('/whatsapp/share', { pdfData: pdfBase64, phoneNumber: whatsappNumber });
        // Note: You need to implement a server-side endpoint to handle the WhatsApp sharing process.
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const PrintDiv = () => {
    var new_str = document.getElementById('demo').innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = new_str;
    window.print();
    document.body.innerHTML = originalContents;
    return false;
  };

  var mediaQueryList = window.matchMedia('print');
  mediaQueryList.addListener(function (mql) {
    if (mql.matches) {
      console.log('before print dialog open');
    } else {
      window.location.reload();
      setPrintTrigger(false);
      console.log('after print dialog closed');
    }
  });
  const handleAddRecord = e => {
    dispatch(CRUDRecordPopup(true));
    setRecordCRUDpopup(true);
  };

  const handleEditorChange = value => {
    setEditorValue(value);
  };

  const handleSaveEditedReport = async () => {
    try {
      const nextHtml = editorValue || response || '';
      loaderchange(true);
      const response = await dispatch(
        updatePatientReport({
          id: reportViewId,
          payload: {
            report_template: nextHtml,
          },
        })
      );

      if (response?.payload?.status?.code === 200) {
        loaderchange(false);
        popupalert('true');
        popuptext('Report updated successfully');
        setTimeout(() => {
          popupalert('false');
        }, 1500);
        window.location.href = '/patientreports';
      } else {
        loaderchange(false);
        popupalert('true');
        popuptext('Network went wrong, Please try after some time.');
        setTimeout(() => {
          popupalert('false');
        }, 2000);
      }
    } catch (error) {
      loaderchange(false);
      popupalert('true');
      popuptext('Unable to update report');
      setTimeout(() => {
        popupalert('false');
      }, 2000);
    }
  };
  const shareMessage = 'Check out this link: https://google.com'; // Message to share
  const phoneNumber = '9182344486'; // WhatsApp number to share with

  const handleShare = () => {
    const apiUrl = `https://api.whatsapp.com/send?phone=${encodeURIComponent(phoneNumber)}&text=${encodeURIComponent(shareMessage)}`;
    window.open(apiUrl, '_blank');
  };

  useEffect(() => {
    console.log(response);
  }, [response]);

  return (
    <>
      <div className={sideActive ? 'patient-view-sa' : 'patient-view'}>
        {/* {recordCRUDpopup && 
      <RecordCRUD
        setclosepopup = {setRecordCRUDpopup}
        loaderchange={loaderchange}
        patientid_share = {patientId}
      />} */}
        <div className='pageWrapper'>
          <div className='content container-fluid'>
            {/* Page Header Start */}
            <div className='page-header'>
              <div className='row'>
                <div className='col'>
                  <h3 className='page-title'>History</h3>
                  <ul className='breadcrumb'>
                    <li className='breadcrumb-item'>
                      <Link to='/' style={{textDecoration: 'none', color: 'black'}}>
                        Dashboard
                      </Link>
                    </li>
                    <li className='breadcrumb-item'>
                      <Link to={fetchReportViewType === 'Patient Billing' ? '/patient_billing' : '/patientreports'} style={{textDecoration: 'none', color: 'black'}}>
                        {fetchReportViewType === 'Patient Billing' ? 'Patient Billing' : 'Patient Reports'}
                      </Link>
                    </li>
                    <li className='breadcrumb-item active'>History</li>
                  </ul>
                </div>
              </div>
            </div>
            {!isEditMode && (
              <div className='row'>
                <div className='buttonHeader'>
                  <button
                    className='addPatientRecordbtn'
                    style={{marginRight: '20px'}}
                    onClick={e => {
                      setPrintTrigger(true);
                      PrintDiv();
                    }}>
                    Print
                  </button>
                  <button
                    className='addPatientRecordbtn'
                    style={{marginRight: '20px'}}
                    onClick={e => {
                      handleShare(e);
                    }}>
                    Share
                  </button>
                </div>
              </div>
            )}
            <div
              // className="profile-menu"
              className='profile-menu '
              id='demo'
              ref={divRef}
              style={{margin: '0 auto', border: 'none'}}
              // id="section-to-print"
            >
              {isEditMode ? (
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', paddingBottom: '20px'}}>
                  <span className='middleInput'>
                    <Editor
                      apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                      key={reportViewId}
                      initialValue={response || ''}
                      init={{
                        height: '800px',
                        width: '1200px',
                        plugins: [
                          'advlist autolink lists link image charmap print preview anchor',
                          'searchreplace visualblocks code fullscreen',
                          'insertdatetime media table paste code help wordcount',
                          'table'
                        ],
                        toolbar:
                          'undo redo | blocks | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | code'
                      }}
                      onEditorChange={handleEditorChange}
                    />
                  </span>
                  <div style={{display: 'flex', gap: '12px', marginTop: '16px'}}>
                    <button
                      className='Button_Create'
                      style={{width: '140px'}}
                      onClick={handleSaveEditedReport}>
                      Save Changes
                    </button>
                    <button
                      className='Button_Create'
                      style={{width: '140px', backgroundColor: '#999'}}
                      onClick={() => window.location.href = '/patientreports'}>
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                <div
                  className='report_view_new'
                  id='section-to-print'
                  style={{
                    maxWidth: '1150px',
                    minWidth: '1150px',
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'flex-start',
                    alignContent: 'center',
                    flexDirection: 'column',
                    border: 'none'
                  }}
                  dangerouslySetInnerHTML={{
                    __html: response
                  }}></div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewPatientReport;
